(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /* Editor only. A block-level re-render (editing a category heading or icon)
     patches the accordion without re-rendering this section and fires no
     shopify:* event, so its tile would go stale. The fresh block brings a
     filled template (the server-side lift empties them): copy it into the
     tile with the same block id, keeping the slide element the slideshow
     already tracks. */
  if (window.Shopify?.designMode) {
    const syncFaqTiles = () => {
      document.querySelectorAll('.faq').forEach((faq) => {
        faq.querySelectorAll('.faq__groups > .accordion--faq > template').forEach((template) => {
          const fresh = template.content.querySelector('.faq__tile');
          const tile = fresh && faq.querySelector(`.faq__nav [data-faq-tile="${CSS.escape(fresh.dataset.faqTile)}"]`);
          if (!tile) return;
          tile.className = fresh.className;
          tile.setAttribute('href', fresh.getAttribute('href'));
          tile.innerHTML = fresh.innerHTML;
          template.content.replaceChildren();
        });
      });
    };
    new MutationObserver(syncFaqTiles).observe(document.documentElement, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
